import React,{useEffect,useContext} from 'react';
import { AppContext } from '../../store/appContext';
import "./edelmetalle-startegie.scss";
import axios from "axios";
import { useDispatchHelpers } from "../../store/dispatchhelper";
import Banner from '../../components/banner/banner';
import WebLoader from '../../components/webLoader/WebLoader';
import { Fade } from 'react-awesome-reveal';
const EdelmetalleStrategie = () => {

  const {
    state: { baseUrl, edelmetalle_strategie, lang },
  } = useContext(AppContext);
  const { dispatchAction } = useDispatchHelpers();
  const isDataReady = Object.keys(edelmetalle_strategie).length > 0;

  useEffect(() => {
    axios.get(`${baseUrl}edelmetall-strategie`).then((response) => {
      dispatchAction("setEdelmetalleStrategieData", response?.data?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Find all span elements inside a div with class "page-container" that have style="color: white;"
    const spans = document.querySelectorAll('.page-container span[style="color: white;"]');
    // Add a class to each of these spans
    spans.forEach(span => {
      span.classList.add('white-text');
    });
     // Find all span elements that have style="color: rgb(212, 185, 123);"
     const goldSpans = document.querySelectorAll(
      ' span[style="color: rgb(212, 185, 123);"]'
    );
    // Add a class to each of these spans
    goldSpans.forEach((span) => {
      span.classList.add("gold-text");
    });
  }, [edelmetalle_strategie]);
  
  return (
    <React.Fragment>
      <WebLoader isLoading={!isDataReady} />
      <div className="edelmetalle-strategie-page page">
      {edelmetalle_strategie && isDataReady && (
        <React.Fragment>
        {<Banner mediaUrl={edelmetalle_strategie.banners[0].path} title={edelmetalle_strategie.banners[0]["title_"+lang]}/>}
        <div className="page-container" id='page-container'>
        <Fade triggerOnce={true} duration={1000} fraction={0.3}>
          <h2 className="title" dangerouslySetInnerHTML={{ __html: edelmetalle_strategie.edelmetalle_strategie[0]["title_"+lang] }} />
          <img src={edelmetalle_strategie.edelmetalle_strategie[0].image} alt="edelmetalle-strategie-image" />
          <p className="desc" dangerouslySetInnerHTML={{ __html: edelmetalle_strategie.edelmetalle_strategie[0]["description_"+lang] }} />
        </Fade>
        </div>
        </React.Fragment>)}
      </div>
    </React.Fragment>
  );
}

export default EdelmetalleStrategie;